// appZoom.ts — desktop-skaalauksen (CSS zoom) kertoimen luku JS-puolelle.
//
// OperatorShell asettaa isoilla näytöillä `zoom`-portaan juurelleen (.op-shell)
// ja saman arvon CSS-muuttujaan `--app-zoom`. CSS zoom EI vaikuta
// window.innerWidthiin eikä hiiritapahtumien clientX/clientY-arvoihin — ne
// pysyvät skaalaamattomina laitepikseleinä. Kun tällainen arvo sijoitetaan
// zoomatun kuoren sisälle (fixed-paneelin sijainti, raahausdelta), se on
// kerrointa liian iso. Jaa arvo tällä kertoimella.

/**
 * Palauttaa nykyisen kuoren zoom-kertoimen (1 = ei skaalausta).
 * Turvallinen SSR:ssä ja testeissä — palauttaa aina 1 jos arvoa ei löydy.
 */
export function getAppZoom(): number {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 1;
  try {
    const el = document.querySelector('.op-shell') ?? document.body;
    if (!el) return 1;
    const raw = getComputedStyle(el).getPropertyValue('--app-zoom');
    const parsed = parseFloat(raw);
    if (!Number.isFinite(parsed) || parsed <= 0) return 1;
    return parsed;
  } catch {
    return 1;
  }
}
